import { render, staticRenderFns } from "./ColumnsChart.vue?vue&type=template&id=34ee302a&"
import script from "./ColumnsChart.vue?vue&type=script&lang=js&"
export * from "./ColumnsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports